import React from 'react';
import { Formik } from 'formik';
import { auth } from '../redux/authActionCreators';
import { connect } from 'react-redux';
import Spinner from '../Components/BurgerBuilder/Spinner/Spinner';
import { Alert } from 'reactstrap';


const mapDispatchToProps = dispatch => {
    return {
        auth: (email, password, mode) => dispatch(auth(email, password, mode)),
    }
}
const mapStateToProps = state => {
    return {
        authLoading: state.authLoading,
        authFailedMsg: state.authFailedMsg,
    }
}

class Authantication extends React.Component {
    state = {
        mode: 'Login',
    }

    switchModeHandler = () => {
        this.setState({ mode: this.state.mode === 'Login' ? 'Sign Up' : 'Login' })
    }
    render() {
        let error = null;
        if (this.props.authFailedMsg !== null) {
            error = <Alert color='danger'>{this.props.authFailedMsg}</Alert>
        }
        let form = null;
        if (this.props.authLoading) {
            form = <Spinner />
        } else {
            form = <Formik
                initialValues={{
                    email: '',
                    password: '',
                    confirmPassword: '',
                }}

                onSubmit={
                    (values) => this.props.auth(values.email, values.password, this.state.mode)
                }

                validate={
                    (values) => {
                        let errors = {};
                        if (!values.email) errors.email = '*Required';
                        else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
                            errors.email = 'Invalid Email'
                        }

                        if (!values.password) errors.password = '*Required';
                        else if (values.password.length < 6) errors.password = 'Must be greater than 5 character';

                        if (this.state.mode === 'Login') {
                            if (!values.confirmPassword) errors.confirmPassword = '*Required';
                            else if (values.password !== values.confirmPassword) {
                                errors.confirmPassword = 'Password dose not match'
                            }
                        }

                        return errors;
                    }
                }
            >
                {
                    ({ values, handleSubmit, handleChange, errors }) => (
                        <div
                            style={{
                                border: '1px solid grey',
                                borderRadius: '7px',
                                boxShadow: '1px #888888',
                                padding: '20px',
                                backgroundColor: '#F1F3F4'
                            }}
                        >
                            <form onSubmit={handleSubmit}>
                                <h4
                                    style={{
                                        border: '1px solid grey',
                                        borderRadius: '7px',
                                        boxShadow: '1px #888888',
                                        padding: '5px',
                                        backgroundColor: 'lightblue',
                                        cursor: 'pointer',
                                        marginBottom: '20px '

                                    }}
                                    onClick={this.switchModeHandler}
                                >Switch to {this.state.mode}</h4>
                                <input
                                    name='email'
                                    placeholder='Your Email'
                                    value={values.email}
                                    className='form-control'
                                    onChange={handleChange}
                                /><span style={{ color: 'red' }}>{errors.email}</span>
                                <br />

                                <input
                                    name='password'
                                    placeholder='Password'
                                    value={values.password}
                                    className='form-control'
                                    onChange={handleChange}
                                /><span style={{ color: 'red' }}>{errors.password}</span>
                                <br />
                                {
                                    this.state.mode === 'Sign Up' ? null : <div>
                                        <input
                                            name='confirmPassword'
                                            placeholder='Confirm Password'
                                            value={values.confirmPassword}
                                            className='form-control'
                                            onChange={handleChange}
                                        /><span style={{ color: 'red' }}>{errors.confirmPassword}</span>
                                        <br />
                                    </div>
                                }

                                <button type='submit' className='btn btn-success'
                                    style={{
                                        marginTop: '10px'
                                    }}
                                >{this.state.mode === 'Login' ? 'Sign Up' : 'Login'}</button>

                            </form>
                        </div>
                    )
                }
            </Formik>
        }
        return (
            <div
                className='m-auto col-md-8'
            >
                {error}
                {form}
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Authantication);